
import React, { useContext, useEffect, useState } from 'react';
import FormValidatorCtxBo from './FormValidatorCtxBo';


// *** Form Context Type
type FormValidatorCtxType = {
    formValidatorCtxBo: FormValidatorCtxBo,
    fireFormValidatorCtxBo: () => void
}

// *** ValidationContextProvider
const ignoreValue: FormValidatorCtxType = {
    formValidatorCtxBo: new FormValidatorCtxBo(),
    fireFormValidatorCtxBo: () => { }
};

export const FormValidatorContext = React.createContext(ignoreValue);

type FormValidatorProviderParam = {
    onSubmit: (error: boolean) => void
}

export const FormValidatorProvider: React.FC<FormValidatorProviderParam> = ({ onSubmit: onSubmitF, children }) => {
    const [bo, setBo] = useState(new FormValidatorCtxBo());

    const fireBo = () => {
        setBo(new FormValidatorCtxBo());
    }

    const onSubmit = (event: any) => {
        event.preventDefault();

        // Validierungen werden angestossen    
        FormValidatorCtxBo.prepareFormValidationStart();
        fireBo();
    }

    // useEffect wird aufgerufen sobald die Seite mit ALLEN Kindelementen gerendert wurde.
    // Nach dem Render der Kindelemente ist die Validierung durchlaufen.
    // Erst dann wird onSubmit aufgerufen.
    useEffect(() => {

        // Der Validation Trigger startet mit 0
        // der erste Aufruf wird ignoriert
        if (FormValidatorCtxBo.runFormValidation) {
            onSubmitF(FormValidatorCtxBo.error);

            if (FormValidatorCtxBo.doOnSubmitButton) {
                FormValidatorCtxBo.doOnSubmitButton(FormValidatorCtxBo.error);
            }
        }

        FormValidatorCtxBo.prepareFormValidationEnd();
        fireBo();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [FormValidatorCtxBo.runFormValidationTrigger])



    return <FormValidatorContext.Provider value={{ formValidatorCtxBo: bo, fireFormValidatorCtxBo: fireBo }}>
        <form onSubmit={onSubmit} noValidate autoComplete="off">
            {children}
        </form>
    </FormValidatorContext.Provider >
}
const useFormValidatorCtx = () => {
    return useContext(FormValidatorContext);
}

export default useFormValidatorCtx;